import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";

import {Observable} from "rxjs";

import {BaseHttpService} from "@shared/services-http/base-http.service";
import {PermissionService} from "@shared/services/permission.service";

import {DataSharingLink} from "@data-sharing/models/data-sharing-link";
import {DataSharingLinkPatchRequest} from "@data-sharing/http-services/requests/data-sharing-link-patch.request";
import {PostLinkRequest} from "@data-sharing/http-services/requests/post-link.request";

@Injectable({
  providedIn: 'root'
})
export class DataSharingHttpService extends BaseHttpService {

  constructor(
    private httpClient: HttpClient,
    private permissionService: PermissionService
  ) {
    super();
  }

  getAll(): Observable<DataSharingLink[]> {
    if (this.permissionService.hasDataSharingAdmin())
      return this.httpClient.get<DataSharingLink[]>(this.getNewApiUrl('/shareLinks/all'));
    else
      return this.httpClient.get<DataSharingLink[]>(this.getNewApiUrl('/shareLinks'));
  }

  delete(linksIds: number[]): Observable<void> {
    return this.httpClient.delete<void>(this.getNewApiUrl('/shareLinks'), {body: linksIds});
  }

  patch(linkId: number, request: DataSharingLinkPatchRequest): Observable<DataSharingLink> {
    return this.httpClient.patch<DataSharingLink>(this.getNewApiUrl('/shareLinks/' + linkId), request);
  }

  post(request: PostLinkRequest): Observable<DataSharingLink> {
    return this.httpClient.post<DataSharingLink>(this.getNewApiUrl('/shareLinks'), request);
  }

  nameExists(name: string): Observable<boolean> {
      return this.httpClient.get<boolean>(this.getNewApiUrl('/shareLinks/nameExists/' + name));
  }
}
